<template>
  <div id="app"><!-- v-if="isAuthenticated" -->
    <b-navbar toggleable type="dark" variant="dark" class="d-md-none">
      <b-navbar-brand href="#">
        <img src="https://apptek-website-assets.s3.amazonaws.com/images/apptek-logo-white-medium.png" width="140" class="my-0" />
      </b-navbar-brand>
      <b-navbar-toggle target="navbar-toggle-collapse">
        <template v-slot:default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="navbar-toggle-collapse" is-nav>
          <Sidebar></Sidebar>
      </b-collapse>
    </b-navbar>
    <b-sidebar
      id="sidebar"
      v-model="sidebarvis"
      width="260px"
      shadow
      no-header
      bg-variant="dark"
      text-variant="light"
      class="d-sm-none d-none d-md-block"
      :no-close-on-route-change="noCloseOnChange"
      v-b-visible="handleVisible"
    >
      <!-- <template #footer="{ hide }">
       <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
       </div>
      </template> -->
      <Sidebar></Sidebar>
    </b-sidebar>
    <b-container fluid>
      <b-row>
        <b-col
          :style="'margin-left:' + marginLeft + 'px'"
          class="py-3 mt-4 mr-3"
        >
          <transition name="slide-fade" mode="out-in">
            <router-view />
          </transition>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_crm.js'
import Sidebar from './components/Sidebar.vue'
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import Vue from 'vue'
import store from './store'

export default {
  components: {
    Sidebar
  },
  data () {
    return {
      noCloseOnChange: true,
      expanded: 0,
      profile: null,
      isAuthenticated: false
    }
  },
  computed: {
    sidebarvis: {
      get () {
        return this.$store.state.sidebarvis
      },
      set (value) {
        this.$store.commit('SET_SIDEBARVIS', value)
      }
    },
    sidebarslide () {
      return this.$store.state.sidebarslide
    },
    marginLeft () {
      return this.sidebarvis ? 285 : 10
    },
    userId () {
      var token = Vue.$cookies.get(process.env.VUE_APP_AUTH_COOKIE_NAME)
      var decoded = jwt_decode(token)
      return decoded.sub
    }
  },
  methods: {
    handleVisible (isVisible) {
      this.$store.commit('SET_SIDEBARVIS', isVisible)
    },
    toggleSlide () {
      this.$store.commit('SET_SIDEBARSLIDE', !this.sidebarslide)
    }
    // beforeWindowUnload (e) { // if the user closes the window, close the websocket connection
    //   console.log('Before window unload event')
    //   this.$store.state.websocket.connection.close()
    //   e.preventDefault()
    // }
  },
  // beforeDestroy () {
  //   window.removeEventListener('beforeunload', this.beforeWindowUnload)
  // },
  created () {
    apiClient.get('/api/authenticated')
      .then(response => {
        this.isAuthenticated = true
      })
    const url = process.env.VUE_APP_WEBSOCKETS + '?user_id=' + this.userId
    // console.log('Connection on url ' + url)
    store.state.websocket.connection = new WebSocket(url)
    store.state.websocket.connection.onmessage = function (event) {
      // console.log(event.data)
      const task = JSON.parse(event.data)
      // console.log(task)
      store.dispatch('putTask', task)
    }
    store.state.websocket.connection.onopen = function (event) {
      // console.log(event)
      // console.log('Successfully connected to the websocket server.')
    }
    this.$store.dispatch('loadProfile', {}) // action in store/index.js
    this.$store.dispatch('loadTasks', 'translate')
    this.$store.dispatch('loadTasks', 'transcribe')
    this.$store.dispatch('loadModels', {})
    this.$store.dispatch('loadPayments', {})
  }
  // async mounted () {
  //   this.$store.dispatch('loadProfile', {}) // action in store/index.js
  //   this.$store.dispatch('loadTasks', {})
  //   this.$store.dispatch('loadModels', {})
  //   this.$store.dispatch('loadPayments', {})
  // }
}

</script>

<style scoped>
/** Tabs */
.nav-tabs .nav-link,
.nav-tabs .nav-link.active {
  color: #000 !important;
  font-weight: bold;
}

/** Light grey for informational text and icons  */
.minor-info {
  color: #aaa;
}

/** Clean up the modal dialogs */
.modal-header {
  border-bottom: 0 none !important;
}

.modal-footer {
  border-top: 0 none !important;
}

/** Transitions  */
.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.15s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>
